module.exports = __webpack_public_path__ + "lato-heavy-2ce4d82354fdf1be1788c526d94eefc1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-heavy/lato-heavy.woff
// module id = 1063
// module chunks = 0